import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';

const pages = [
  { label: 'Home', path: '/' },
  { label: 'Booking', path: '/booking' },
  { label: 'Contact', path: '/contact' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Pets', path: '/pets' },
  { label: 'Things to Do', path: '/things-to-do' },
  { label: 'Reviews', path: '/reviews' }
];

export default function MuiNavbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar 
      position="static" 
      color="primary" 
      sx={{ 
        background: '#0d1a2f',
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        minHeight: '64px',
        height: '64px',
        display: 'flex',
        flexDirection: 'column',
        '&.MuiAppBar-root': {
          minHeight: '64px',
          height: '64px'
        }
      }}
    >
      <Toolbar 
        disableGutters
        sx={{
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px',
          boxSizing: 'border-box',
          minHeight: '64px !important',
          height: '64px',
          '&.MuiToolbar-root': {
            minHeight: '64px',
            height: '64px'
          }
        }}
      >
        {/* Mobile Hamburger */}
        <Box sx={{ 
          flexGrow: 1, 
          display: { xs: 'flex', md: 'none' },
          maxWidth: '100%',
          overflow: 'hidden'
        }}>
          <IconButton
            size="large"
            aria-label="menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            {pages.map((page) => (
              <MenuItem key={page.path} onClick={handleCloseNavMenu} component={RouterLink} to={page.path}>
                <Typography textAlign="center">{page.label}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
        {/* Desktop Links */}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
          {pages.map((page) => (
            <Button
              key={page.path}
              component={RouterLink}
              to={page.path}
              sx={{ my: 2, color: 'white', display: 'block', fontWeight: 600 }}
            >
              {page.label}
            </Button>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
